import { render, staticRenderFns } from "./CollaboratorsPage.vue?vue&type=template&id=4b4ab485&scoped=true&"
import script from "./CollaboratorsPage.vue?vue&type=script&lang=js&"
export * from "./CollaboratorsPage.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratorsPage.vue?vue&type=style&index=0&id=4b4ab485&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4ab485",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b4ab485')) {
      api.createRecord('4b4ab485', component.options)
    } else {
      api.reload('4b4ab485', component.options)
    }
    module.hot.accept("./CollaboratorsPage.vue?vue&type=template&id=4b4ab485&scoped=true&", function () {
      api.rerender('4b4ab485', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/settingsPage/CollaboratorsPage.vue"
export default component.exports